import { Component, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/auth/authentication.service';
import { environment } from '../environments/environment';
import { PermissionsService } from '@app/shared/services/permissions/permissions.service';
import { QueryParamsErrorCodesEnum } from 'auth';
import { Subscription } from 'rxjs';
import { captureNbFacilityIdFromUrl, installFacilityLinkInterceptor } from '@app/react/lib/facilityLinks';

@Component({
	selector: 'rc-root',
	templateUrl: './app.component.html',
	styleUrls: ['app.component.scss'],
})
export class AppComponent {
	constructor(
		private authService: AuthenticationService,
		private permissionsService: PermissionsService,
		private router: Router,
		private ngZone: NgZone
	) {
		const currentLocation: string = window.location.pathname;

		(window as any).ngZone = this.ngZone;

		if (!authService.isLoggedIn()) {
			if (!currentLocation.includes('login')) {
				let subscription: Subscription;
				const onSuccess = () => {
					subscription?.unsubscribe();
					window.location.reload();
				};

				subscription = this.authService.renewToken(onSuccess);
			}

			return;
		}

		captureNbFacilityIdFromUrl();
		installFacilityLinkInterceptor();

		this.authService.currentOrganization.subscribe(async response => {
			if (!response) return;
			console.log('AppComponent - constructor');
			await this.permissionsService.getMyPermissions(response.id);
			console.log('Got permissions');

			const { firstName, lastName, id, email } = this.authService.getTokenData();

			const loggedUser = {
				user_id: id,
				name: `${firstName} ${lastName}`,
				email,
			};

			const organization = {
				company_id: response.id,
				name: response.name,
				created_at: response['createdAt'],
				email: response.email,
			};

			window['Intercom']('boot', {
				app_id: environment.INTERCOM_ID,
				...loggedUser,
				company: { ...organization },
			});
		});

		if (this.authService.isLoggedIn()) {
			this.authService.fetchActiveOrganization().subscribe({
				error: error => this.authService.logout(QueryParamsErrorCodesEnum.UNAUTHORIZED),
			});
		} else {
			window['Intercom']('boot', {
				app_id: 'r8n5hkbk',
			});
		}
	}

	private navigateToLogin() {
		this.router.navigate(['/login']);
	}

	async updateUserPermissions() {
		if (!document.hidden) {
			console.log('updateUserPermissions - updating permissions');
			await this.permissionsService.getMyPermissions(this.authService.currentOrganization.value.id);
			console.log('updateUserPermissions - permissions updated');
		}
	}
}
